/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Create Workspace Invite Request Body
 */
export interface CreateWorkspaceMemberInviteBody { 
    /**
     * A email to invite
     */
    invitee_email: string;
    /**
     * The role the user will have in the workspace owner WorkspaceMemberRoleOwner developer WorkspaceMemberRoleDeveloper
     */
    role: CreateWorkspaceMemberInviteBody.RoleEnum;
}
export namespace CreateWorkspaceMemberInviteBody {
    export type RoleEnum = 'owner' | 'developer';
    export const RoleEnum = {
        Owner: 'owner' as RoleEnum,
        Developer: 'developer' as RoleEnum
    };
}


